import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { init as initUserCenter } from '@xgimi-private/user-center';

import './utils/monitor';
import Language from './languages';

import createStore from './store';

import Layout from './layouts/Base';
import Router from './router';

import * as serviceWorker from './serviceWorker';

const store = createStore();
// 初始化用户中心
initUserCenter(store);

ReactDOM.render(
  <Provider store={store}>
    <Language>
      <Layout>
        <Router/>
      </Layout>
    </Language>
  </Provider>,
  document.querySelector('#root'),
);

serviceWorker.unregister();
